import { render, staticRenderFns } from "./FolderIcon.vue?vue&type=template&id=ea4b9b9e&scoped=true"
import script from "./FolderIcon.vue?vue&type=script&lang=js"
export * from "./FolderIcon.vue?vue&type=script&lang=js"
import style0 from "./FolderIcon.vue?vue&type=style&index=0&id=ea4b9b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4b9b9e",
  null
  
)

export default component.exports